import { resolveErpIds } from "../filters/reducer";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getProyectosKpis,
    getProyectosEvolucion,
    getProyectosMediaEvolucion,
    getProyectosPorTipo,
    getProyectosPorPais,
    getProyectosTareasPendientes,
    getProyectosParcial,
    getProyectosRendimiento,
} from '../../helpers/proyectosApi';

const getFilters = (getState) => {
    const state = getState();
    return { empresaId: resolveErpIds(state), year: state.Filters.year };
};

export const getProyectosKpisData = createAsyncThunk(
    "dashboardProyectos/getKpis",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getProyectosKpis(empresaId, year);
    }
);

export const getProyectosEvolucionData = createAsyncThunk(
    "dashboardProyectos/getEvolucion",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getProyectosEvolucion(empresaId, year);
    }
);

export const getProyectosMediaEvolucionData = createAsyncThunk(
    "dashboardProyectos/getMediaEvolucion",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getProyectosMediaEvolucion(empresaId, year);
    }
);

export const getProyectosPorTipoData = createAsyncThunk(
    "dashboardProyectos/getPorTipo",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getProyectosPorTipo(empresaId, year);
    }
);

export const getProyectosPorPaisData = createAsyncThunk(
    "dashboardProyectos/getPorPais",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getProyectosPorPais(empresaId, year);
    }
);

export const getProyectosTareasData = createAsyncThunk(
    "dashboardProyectos/getTareas",
    async (_, { getState }) => {
        const { empresaId } = getFilters(getState);
        return await getProyectosTareasPendientes(empresaId);
    }
);

export const getProyectosParcialData = createAsyncThunk(
    "dashboardProyectos/getParcial",
    async ({ filtro, segmento } = {}, { getState }) => {
        const { empresaId } = getFilters(getState);
        return await getProyectosParcial(empresaId, filtro, segmento);
    }
);

export const getProyectosRendimientoData = createAsyncThunk(
    "dashboardProyectos/getRendimiento",
    async ({ filtro, segmento } = {}, { getState }) => {
        const { empresaId } = getFilters(getState);
        return await getProyectosRendimiento(empresaId, filtro, segmento);
    }
);
